<template>
<div class="chapter">
<div class="inner_page">
<h2 title="Copyright"></h2>
<p class="small">InterVarsity Press <br/>
  P.O. Box 1400 <br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank"><span class="hyperlinks">www.ivpress.com</span></a><br/>
  Email: <a href="mailto:email%40ivpress.com?subject="><span class="hyperlinks">email@ivpress.com</span></a></p>
<p class="small">©2013 by Michael Card</p>
<p class="small">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="small">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at &lt;<a href="http://www.intervarsity.org" target="_blank"><span class="hyperlinks">www.intervarsity.org</span></a>&gt;.</p>
<p class="small">Scripture quotations, unless otherwise indicated, are taken from the Holman Christian Standard Bible, copyright ©1999, 2000, 2002, 2003 by Holman Bible Publishers, Nashville, Tennessee. Used by permission HCSB Holman Bible Publishers. All rights reserved.</p>
<p class="small">Design: Cindy Kiple<br/>
  Images: Jesus healing a leper (mosaic), Byzantine School, Duomo, Monreale, Sicily, Italy, Giraudon. The Bridgeman Art Library.</p>
<p class="small">ISBN 978-0-8308-3812-7 (print)<br/>
  ISBN 978-0-8308-8441-4 (digital)</p>
<p class="small"><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?7ae21eda